/**
 * Created by Kaku.Guo on 2018/12/6.
 */
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { hasValue, formatLink } from '../../utils';
import { Message } from '../../components';
import { BasePageView, mapStateToProps, mapDispatchToProps } from '../index';
import { AssetActions, PageActions } from '../../actions';

const sellerMapDispatchToProps = (dispatch) => {
    const actions = mapDispatchToProps(dispatch);
    actions.listAssets = (model) => {dispatch(AssetActions.sellerAssets(model));};
    actions.handleChange = (func, model) => {dispatch(PageActions[func](model));};
    return actions;
};

/* Add meta tag descriptions for specific profiles */
const addMetaDescription = (sellerName) => {
    switch (sellerName) {
        case 'Epic+Games':
            return 'epic.ue.marketplace.meta.epic_content';
        default:
            return null;
    }
};

@connect(mapStateToProps, sellerMapDispatchToProps)
class SellerAssetsView extends BasePageView {
    constructor(props) {
        const { match: { params: { sellerName } } } = props;
        const staticParams = {
            sellerName
        };
        super(props, staticParams, {
            contentHeader: {
                code: 'messages.com.epicgames.plugin.store.header.profile'
            },
            pageTitleCode: 'messages.com.epicgames.plugin.store.title.profile',
            pageTileArgs: [sellerName],
            descriptionCode: addMetaDescription(sellerName)
        });
    }

    render() {
        const { data = {}, isLoggedIn } = this.props;
        const { sellerProfile = {} } = data;
        const {
            name,
            isDiscontinued,
            facebook,
            twitter,
            blog,
            otherLink,
            website,
            supportEmail
        } = sellerProfile;
        const showSellerDetails = isLoggedIn && !isDiscontinued;

        return (
            <div className="asset-details-container offset-top seller-assets overflow-y-visible">
                {this.getHelmetElement()}
                {this.getSortDropdown()}
                {this.getPaginator()}
                {hasValue(sellerProfile) && (
                    <section className={`profile-assets-container ${isDiscontinued ? 'discontinued' : ''}`}>
                        <div className="sub-header">
                            <h2>
                                <span>{name}</span>
                                {showSellerDetails && (
                                    <span className="social-link">
                                        {facebook && (
                                            <a href={formatLink(facebook)} target="_blank" rel="noopener noreferrer">
                                                <i className="icon-facebook3">&nbsp;</i>
                                            </a>
                                        )}
                                        {twitter && (
                                            <a href={formatLink(twitter)} target="_blank" rel="noopener noreferrer">
                                                <i className="icon-twitter">&nbsp;</i>
                                            </a>
                                        )}
                                        {blog && (
                                            <a href={formatLink(blog)} target="_blank" rel="noopener noreferrer">
                                                <i className="icon-read">&nbsp;</i>
                                            </a>
                                        )}
                                        {otherLink && (
                                            <a href={formatLink(otherLink)} target="_blank" rel="noopener noreferrer">
                                                <i className="icon-link">&nbsp;</i>
                                            </a>
                                        )}
                                    </span>
                                )}
                            </h2>
                        </div>
                        {showSellerDetails && (
                            <div className="seller-details">
                                {website && (
                                    <div className="asset-desc-nvs">
                                        <Message code="messages.com.epicgames.plugin.store.asset.support_website" />
                                        <span><a href={formatLink(website)} target="_blank" rel="noopener noreferrer">{website}</a></span>
                                    </div>
                                )}
                                {supportEmail && (
                                    <div className="asset-desc-nvs">
                                        <Message code="messages.com.epicgames.plugin.store.asset.support_email" />
                                        <span><a href={`mailto:${supportEmail}`}>{supportEmail}</a></span>
                                    </div>
                                )}
                            </div>
                        )}
                        <hr />
                    </section>
                )}
                {isDiscontinued ? (
                    <h5 className="seller-discontinued">
                        <Message code="messages.com.epicgames.plugin.store.header.seller_discontinued" />
                    </h5>
                ) : (
                    <Fragment>
                        {this.getFilterPanel()}
                        <div className="category-container">
                            {this.getFilterLink()}
                            {this.getAssetList()}
                        </div>
                        <div className="clearfix" />
                    </Fragment>
                )}
                {this.getPaginator()}
            </div>
        );
    }
}
export default withRouter(SellerAssetsView);